import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "alvorada",
        nomePrefeitura: "Prefeitura Municipal de Alvorada do Sul",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/alvoradadosul/logos/brasao.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/alvoradadosul/logos/brasao.png",
        municipio: "| Alvorada do Sul - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape:
                "Praça Prefeito Antônio de Souza Lemos, 32 - Telefone (43) 3157-1000 Email: administrativo@alvoradadosul.pr.gov.br",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-51.2313357, -22.7811463],
            zoom: 18,
        },
    },
    api: {
        url: "https://api-prd.semv.com.br/alvoradadosul/",
    },
    geoserver: {
        url: "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
